import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed } from "vue";
import { useHead } from "@vueuse/head";
import { createLocale, enUS, darkTheme, lightTheme } from "naive-ui";
import { useMetaStore } from "@/store/meta";
import { useUXStore } from "@/store/ux";
import { useIsMobile } from "@/utils/reactive";
import Layout from "@/components/Layout.vue";
import System from "@/components/System.vue";
import NotificationManager from "@/components/notifications/NotificationManager.vue";
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var metaStore = useMetaStore();
    var uxStore = useUXStore();
    var isMobile = useIsMobile();
    var locale = createLocale({
      Input: {
        placeholder: ""
      },
      InputNumber: {
        placeholder: ""
      }
    }, enUS);
    var theme = computed(function () {
      return uxStore.theme === "dark" ? darkTheme : lightTheme;
    });
    var maxNotifications = computed(function () {
      return isMobile.value ? 1 : 3;
    });
    useHead({
      title: computed(function () {
        return metaStore.title;
      }),
      meta: [{
        name: "description",
        content: computed(function () {
          return metaStore.head.description || "";
        })
      }]
    });
    return function (_ctx, _cache) {
      var _component_n_global_style = _resolveComponent("n-global-style");

      var _component_n_dialog_provider = _resolveComponent("n-dialog-provider");

      var _component_n_message_provider = _resolveComponent("n-message-provider");

      var _component_n_notification_provider = _resolveComponent("n-notification-provider");

      var _component_n_loading_bar_provider = _resolveComponent("n-loading-bar-provider");

      var _component_n_config_provider = _resolveComponent("n-config-provider");

      return _openBlock(), _createBlock(_component_n_config_provider, {
        locale: _unref(locale),
        theme: _unref(theme),
        abstract: ""
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_n_global_style), _createVNode(_component_n_loading_bar_provider, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_n_message_provider, null, {
                default: _withCtx(function () {
                  return [_createVNode(_component_n_dialog_provider, null, {
                    default: _withCtx(function () {
                      return [_createVNode(Layout)];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              }), _createVNode(_component_n_notification_provider, {
                max: _unref(maxNotifications)
              }, {
                default: _withCtx(function () {
                  return [_createVNode(NotificationManager)];
                }),
                _: 1
              }, 8, ["max"]), _createVNode(_component_n_notification_provider, {
                max: _unref(maxNotifications),
                placement: "bottom-right"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(System)];
                }),
                _: 1
              }, 8, ["max"])];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["locale", "theme"]);
    };
  }
});